<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Instrument Score Conditions</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_DeviceCondition()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>
          <button routerLink="/DeviceConditionForm" type="button" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Register New Information </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Days</th>
              <th>Early</th>
              <th>Late</th>
              <th>On Time</th>
              <th>Date</th>
              <th>User</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_DeviceCondition
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_DeviceCondition.length
                      }
            ">
              <td>{{DataList_DeviceCondition.indexOf(item)+1}}</td>
              <td>{{item.day}}</td>
              <td>{{item.tajil}}</td>
              <td>{{item.takhir}}</td>
              <td>{{item.brabar}}</td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>
